import React, { useState, useEffect, useRef } from "react";
import {
  Page,
  Card,
  Text,
  Button,
  InlineStack,
  BlockStack,
  Select,
  Badge,
  ButtonGroup,
  Tag,
  Spinner,
  FormLayout,
  Modal,
  Box,
  Thumbnail,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useNavigate } from "react-router-dom";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import { EditIcon, EditMinor, PlusCircleIcon } from "@shopify/polaris-icons";
import Pagination from "@material-ui/lab/Pagination";
import { capitalizeFirstLetter } from "../../Helpers";
import lebanonIcon from "../../Assets/Images/lb.svg";
import iraqIcon from "../../Assets/Images/iq.svg";
import egyptIcon from "../../Assets/Images/eg.svg";
// Timeframe options as buttons
const timeframeOptions = ["All", "YTD", "Q1", "Q2", "Q3", "Q4"];

export default function Achievements() {
  const navigate = useNavigate();

  const [typeFilter, setTypeFilter] = useState("All");
  const [timeframeFilter, setTimeframeFilter] = useState("All");
  const [achievements, setAchievements] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [selectedItem, setSelectedItem] = useState(null);
  const [modalActive, setModalActive] = useState(false);

  const typeOptions = [
    { label: "All", value: "All" },
    { label: "Sales", value: "sales" },
    { label: "App", value: "app" },
    { label: "Market", value: "market" },
    { label: "Revenue", value: "revenue" },
    { label: "Product", value: "product" },
    { label: "Marketing", value: "marketing" },
    { label: "Customer Success", value: "customer_success" },
    { label: "Operations", value: "operations" },
    { label: "Team", value: "team" },
    { label: "Innovation", value: "innovation" },
    { label: "Finance", value: "finance" },
  ];

  // Fetch achievements with filters
  const fetchAchievements = async () => {
    setIsLoading(true);
    try {
      const params = new URLSearchParams();
      params.append("per_page", perPage);
      params.append("page", refBoolPage.current ? page : 1);

      if (typeFilter !== "All") {
        params.append("filter[type]", typeFilter);
      }
      if (timeframeFilter !== "All") {
        params.append("filter[timeline]", timeframeFilter);
      }
      if (country !== "") {
        params.append("filter[country]", country);
      }

      const response = await axios.get(`/achievements`, { params });

      const data = response.data.data.data || [];
      setAchievements(data);
      setTotalPages(response.data.data.total || 1);
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  };
  const refBoolPage = useRef(true);
  const [page, setPage] = useState(1);
  const [perPage] = useState(50);
  const [totalPages, setTotalPages] = useState(1);
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  const [country, setCountry] = useState("");

  useEffect(() => {
    fetchAchievements();
  }, [typeFilter, timeframeFilter, page, country]);

  const handleAddAchievement = () => navigate("/admin/achievements/new");

  const handleOpenModal = (item) => {
    setSelectedItem(item);
    setModalActive(true);
  };

  const handleCloseModal = () => {
    setSelectedItem(null);
    setModalActive(false);
  };
  const [countryButtons, setCountryButtons] = useState([]);
  useEffect(() => {
    axios
      .get("/settings/countries")
      .then((res) => {
        const countriesData = res?.data?.data || [];
        const options = [
          { label: "All", value: "" },
          { label: "Mutual", value: "All" },
          ...countriesData.map((country) => ({
            label: country.name,
            value: country.name,
            flag: country.flag,
          })),
        ];
        setCountryButtons(options);
        // setCountry(options?.[0]);
      })
      .catch((err) => console.log(err));
  }, []);
  return achievements ? (
    <Page
      title="Achievements"
      fullWidth
      primaryAction={
        <Button
          variant="primary"
          onClick={handleAddAchievement}
          icon={PlusCircleIcon}
        >
          Add Achievement
        </Button>
      }
    >
      <Card>
        <BlockStack gap="500">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center", // 👈 centers all vertically
              flexWrap: "wrap",
              gap: "1rem",
            }}
          >
            {/* 🔹 Left side: Filters */}
            <InlineStack gap="300" wrap align="center">
              <Select
                label="Type"
                options={typeOptions}
                value={typeFilter}
                onChange={setTypeFilter}
              />

              {/* 🔹 Timeframe filter */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  minWidth: "150px",
                }}
              >
                <Text
                  as="span"
                  variant="bodyMd"
                  fontWeight="medium"
                  style={{ marginBottom: "0.4rem" }}
                >
                  Timeframe
                </Text>
                <ButtonGroup segmented>
                  {timeframeOptions.map((tf) => (
                    <Button
                      key={tf}
                      pressed={timeframeFilter === tf}
                      onClick={() => setTimeframeFilter(tf)}
                    >
                      {tf}
                    </Button>
                  ))}
                </ButtonGroup>
              </div>
            </InlineStack>

            {/* 🔹 Right side: Country buttons */}
            <div
              style={{
                display: "flex",
                alignItems: "center", // 👈 centers this group vertically
              }}
            >
              <ButtonGroup segmented>
                {countryButtons.map((t) => (
                  <Button
                    key={t.value}
                    pressed={country === t.value}
                    onClick={() => setCountry(String(t.value))}
                  >
                    {t.flag && (
                      <img
                        src={t.flag}
                        alt={t.label}
                        style={{ width: 20, marginRight: 6 }}
                      />
                    )}
                    {t.label}
                  </Button>
                ))}
              </ButtonGroup>
            </div>
          </div>
        </BlockStack>
      </Card>

      {/* Achievements List */}
      {achievements?.length ? (
        <Card>
          <FormLayout>
            {achievements.map((item, index) => (
              <div
                key={index}
                // rounded
                padding="400"
                onClick={() => handleOpenModal(item)}
                style={{ cursor: "pointer" }}
              >
                <Card>
                  <InlineStack align="space-between" blockAlign="center">
                    {/* Left side: Image + Texts + Tags (vertically centered) */}
                    <InlineStack gap="300" blockAlign="center">
                      {/* Thumbnail */}
                      <div style={{ width: 80, height: 80, flexShrink: 0 }}>
                        <img
                          src={
                            item.image_url ||
                            "https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png"
                          }
                          alt={item.title}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "8px",
                          }}
                        />
                      </div>

                      {/* Text + Tags vertically stacked and centered */}
                      <BlockStack gap="100" align="start">
                        <Text variant="headingMd" as="h3">
                          {item.title}
                        </Text>

                        <Text variant="bodyMd">{item.description}</Text>

                        <Text tone="success" variant="bodySm">
                          {item.text}
                        </Text>

                        <InlineStack gap="100" align="start">
                          {item.tags?.map((tag, idx) => (
                            <Tag key={idx}>{tag}</Tag>
                          ))}
                        </InlineStack>
                      </BlockStack>
                    </InlineStack>

                    {/* Right side: Date + Badge + Edit Icon */}
                    <InlineStack align="start" gap="100">
                      <Text tone="subdued" variant="bodySm">
                        {item.date}
                      </Text>

                      <Badge
                        tone={
                          item.status === "achieved"
                            ? "success"
                            : item.status === "pending"
                            ? "default"
                            : "info"
                        }
                      >
                        {capitalizeFirstLetter(item.status)}
                      </Badge>

                      <Button
                        plain
                        icon={EditIcon}
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/admin/achievements/${item.id}`);
                        }}
                      />
                    </InlineStack>
                  </InlineStack>
                </Card>
              </div>
            ))}
            {Math.ceil(totalPages / perPage) >= 2 && (
              <div
                style={{
                  paddingTop: "10px",
                  textAlign: "center",
                  paddingBottom: "10px",
                }}
              >
                <Pagination
                  count={Math.ceil(totalPages / perPage)}
                  page={page}
                  onChange={handleChangePage}
                  size="large"
                />
              </div>
            )}
          </FormLayout>
        </Card>
      ) : (
        <Card padding="0">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div style={{ width: "25%" }}>
              <img src={emptyListImage} alt="No results" />
            </div>
            <div className="mb-3">
              <Text variant="headingLg" as="h5" color="subdued">
                No results found
              </Text>
            </div>
          </div>
        </Card>
      )}

      {/* Achievement Details Modal */}
      {selectedItem && (
        <Modal
          open={modalActive}
          onClose={handleCloseModal}
          title={selectedItem.title}
          primaryAction={{
            content: "Close",
            onAction: handleCloseModal,
          }}
        >
          <Modal.Section>
            <div className="fixedModalContent">
              <FormLayout>
                {selectedItem.image_url && (
                  // <img
                  //   src={selectedItem.image_url}
                  //   alt={selectedItem.title}
                  //   style={{
                  //     width: "100%",
                  //     height: "200px",
                  //     objectFit: "cover",
                  //     borderRadius: "8px",
                  //     marginBottom: "16px",
                  //   }}
                  // />
                  <Thumbnail source={selectedItem.image_url} />
                )}
                <Text variant="bodyMd" as="p">
                  <b>Description:</b> {selectedItem.description ?? "-"}
                </Text>
                <Text variant="bodyMd" as="p">
                  <b>Text:</b> {selectedItem.text ?? "-"}
                </Text>
                <Text variant="bodyMd" as="p">
                  <b>Type:</b> {selectedItem.type ?? "-"}
                </Text>
                <Text variant="bodyMd" as="p">
                  <b>Status:</b> {selectedItem.status ?? "-"}
                </Text>
                <Text variant="bodyMd" as="p">
                  <b>Timeline:</b> {selectedItem.timeline ?? "-"}
                </Text>
                <Text variant="bodyMd" as="p">
                  <b>Tags:</b>
                </Text>
                <InlineStack gap="100" style={{ marginTop: "8px" }}>
                  {selectedItem.tags?.map((tag, idx) => (
                    <Tag key={idx}>{tag}</Tag>
                  ))}
                </InlineStack>
              </FormLayout>
            </div>
          </Modal.Section>
        </Modal>
      )}

      {isLoading && (
        <div className="spinnerContainer">
          <div className="vertical-center">
            <Spinner size="large" />
          </div>
        </div>
      )}
    </Page>
  ) : (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  );
}
